const actions = {
  fetchPending: 'LOADING::CONTRACTORSREPORT',
  fetchReport: 'FETCH::REPORT',
  fetchReportTypes: 'FETCH::REPORT_TYPES',
  reportTypesFetchPending: 'LOADING::REPORTTYPES',
  failedReportTypes: 'ERROR::REPORTTYPES',
  setReportTypes: 'SET::REPORT_TYPES',
  setReport: 'SET::REPORT',
  setReportOptions: 'SET::REPORT_OPTIONS',
  setSelectedReportType: 'SET::SELECTED_REPORT_TYPE'
}

export const setSelectedReport = state => ({ type: actions.setSelectedReportType, selectedReportType: state })

export default actions



// WEBPACK FOOTER //
// ./src/store/reports/actions.js